export default "__VITE_ASSET__B6qFHlT2__"